import React, { useState, useEffect } from 'react';
import './Header2.css'; // This will contain styles for the header
//import CustomButton from './Button2'; // Import the CustomButton component

const Header2 = ({ onLogout }) => {
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const storedUserDetails = localStorage.getItem('userDetails');
    if (storedUserDetails) {
      const parsedDetails = JSON.parse(storedUserDetails);
      setUserName(parsedDetails.name || 'User');
    }
  }, []);

  return (
    <header className="dashboard-header-v2">
      <div className="header-title-v2">
        <h1>Achievement Report Dashboard</h1>
      </div>
      
      <div className="header-user-v2">
          <span>Welcome, {userName}</span>
          <button className="logout-button-v2" onClick={onLogout}>
            Logout
          </button>
        </div>
    </header>
  );
};

export default Header2;
